import { Signature, UnsavedSignature } from '@paragon/contract-library';

import { SealingService } from '../connections';

export async function fetch(userEmail: string): Promise<readonly Signature[]> {
  return SealingService.get('signatures', { params: new URLSearchParams({ userEmail }) });
}

export function create(signature: UnsavedSignature) {
  return SealingService.post<Signature>('signatures', { data: signature });
}

export function remove(signatureId: number) {
  return SealingService.delete<Signature>(`signatures/${signatureId}`);
}
